import { useState } from 'react';
import translator from '@Components/Utilities/Translator';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import { RadioGroup } from '@mui/material';

const Autocomplete = loadable(() => import('@Components/MuiWrappers/Autocomplete'));

const PartsQuickSearch = (props) => {
    const {
        searchUrl,
        showSearchTypes,
        bgVariant
    } = props;

    const [searchType, setSearchType] = useState('Start');

    const onSearchTypeChange = (e, value) => {
        setSearchType(value);
    };

    return (
        <div className='parts-quick-search'>
            <Stack
                direction="row"
                spacing={1}
                justifyContent="center"
                alignItems="center"
                sx={{
                    color: 'primary.contrastText'
                }}
            >
                <Autocomplete
                    name='PartNumber'
                    label={`${translator.translate('sandhills.tradesites.mvc.findparts')}: ${translator.translate('sandhills.partnum')}`}
                    ajaxOptions={{ enabled: false }}
                    searchOptions={{ url: searchUrl, additionalData: { 'SearchType': searchType }, dataKey: 'PartNumber' }}
                    trackingOptions={{ enabled: false }}
                    styles={{ bgVariant: bgVariant }}
                />
                {showSearchTypes &&
                    <RadioGroup aria-label="Search Type" name="SearchType" onChange={onSearchTypeChange} value={searchType}>
                        <FormControlLabel
                            value="Start"
                            control={
                                <Radio
                                    size="small"
                                    sx={{
                                        padding: '0 9px',
                                        color: 'primary.contrastText',
                                        '&.Mui-checked': {
                                            color: 'primary.contrastText',
                                        }
                                    }}
                                    inputProps={{ role: 'radio' }}
                                />
                            }
                            label={translator.translate('sandhills.tradepubwebsite.mvc.startswith')}
                            sx={{
                                whiteSpace: 'nowrap'
                            }}
                        />
                        <FormControlLabel
                            value="Exact"
                            control={
                                <Radio
                                    size="small"
                                    sx={{
                                        padding: '0 9px',
                                        color: 'primary.contrastText',
                                        '&.Mui-checked': {
                                            color: 'primary.contrastText',
                                        }
                                    }}
                                    inputProps={{ role: 'radio' }}
                                />
                            }
                            label={translator.translate('sandhills.tradepubwebsite.mvc.exactmatch')}
                            sx={{
                                whiteSpace: 'nowrap'
                            }}
                        />
                    </RadioGroup>
                }
            </Stack>
        </div>
    );
};

export default PartsQuickSearch;